const customerComplaintRouter = [
  {
    path: '/customer-complaint',
    name: 'CustomerComplaint',
    component: () => import('@/views/wxapp/customer-complaint'),
    meta: {
      title: '客诉处理'
    },
    children: [
      {
        path: 'complaint-list',
        name: 'ComplaintList',
        component: () => import('@/views/wxapp/customer-complaint/complaint-list'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'response-list',
        name: 'ResponseList',
        component: () => import('@/views/wxapp/customer-complaint/response-list'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'complaint-details',
        name: 'ComplaintDetails',
        component: () => import('@/views/wxapp/customer-complaint/complaint-details'),
        meta: {
          title: '客诉处理'
        }
      },
      {
        path: 'response-details',
        name: 'ResponseDetails',
        component: () => import('@/views/wxapp/customer-complaint/response-details'),
        meta: {
          title: '客诉处理'
        }
      }
    ]
  }
]
export default customerComplaintRouter
